import { useAuthStore } from "../store/auth.store";

/**
 * Returns true if the current user has ALL of the specified permissions.
 * If no permissions are required, returns true.
 */
export function useHasPermission(...requiredPermissions: string[]): boolean {
  const profile = useAuthStore((s) => s.profile);

  if (requiredPermissions.length === 0) return true;
  if (!profile?.permissions) return false;

  const userPermissions = new Set(profile.permissions);
  return requiredPermissions.every((p) => userPermissions.has(p));
}
